var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('page-section', {
    staticClass: "page-section--first page-section--sm"
  }, [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h2', {
    staticClass: "tit tit--lg"
  }, [_vm._v(" 성장의 시간, "), _c('br'), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v("리본바이옴")]), _vm._v("의 도전 ")])]), _c('p', {
    staticClass: "tit tit--sm font-weight-medium line-height-15"
  }, [_vm._v(" 자연에서 시작된 마이크로바이옴 프로바이오틱스 기술이, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 세계인의 건강을 위한 솔루션으로 발전해왔습니다. ")])]), _c('page-section', {
    staticClass: "page-section--last page-section--sm"
  }, [_c('ul', {
    staticClass: "history-list"
  }, _vm._l(_vm.items, function (item) {
    return _c('li', {
      key: item.year
    }, [_c('v-row', {
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-sheet', {
      staticClass: "history-list__year"
    }, [_c('div', {
      staticClass: "tit tit--lg line-height-1"
    }, [_vm._v(" " + _vm._s(item.year) + " ")])])], 1), _c('v-col', [_c('v-sheet', {
      staticClass: "history-list__content"
    }, [_c('v-row', {
      staticClass: "row--sm"
    }, [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "tit tit--xs font-weight-medium line-height-15"
    }, [_vm._v(" " + _vm._s(item.word) + " ")])]), _c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('v-row', {
      staticClass: "row--xs txt txt--lg line-height-15"
    }, _vm._l(item.text, function (child) {
      return _c('v-col', {
        key: child,
        attrs: {
          "cols": "12"
        }
      }, [_c('v-row', {
        attrs: {
          "no-gutters": ""
        }
      }, [_c('v-col', {
        staticClass: "mr-1",
        attrs: {
          "cols": "auto"
        }
      }, [_vm._v("·")]), _c('v-col', [_c('p', {
        domProps: {
          "innerHTML": _vm._s(child)
        }
      })])], 1)], 1);
    }), 1)], 1)], 1)], 1)], 1)], 1)], 1);
  }), 0)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }